/* eslint-disable import/prefer-default-export */
import { GET_STANDING } from './types'
import { Standing } from '../../apis'

export const getStanding = (accessToken, tournamentId, params = {}) => async (dispatch) => {
  const standing = new Standing(accessToken, dispatch)
  const func = async () => standing.get(tournamentId, params)
  return standing.d(func, GET_STANDING)
}
